import { API } from "@swivl-mono/api-helper";
import { LocationVarKey } from "@swivl-mono/types";
import { GenericTableRowInterface } from "@swivl-mono/types";
import { useEffect, useState } from "react";

import { useLocationVariables } from "../../../Hooks/useLocationVariables";
import { Member } from "../../../Models/Member/Member.Current";

export default function AnalyticsSettingsView() {
  // S3 URLs
  const [analyticsReportURLs, setAnalyticsReportURLs] = useState<{ link: string; name: string }[]>([]);
  // const [directoryName, setDirectoryName] = useState<string | undefined>(undefined);
  const variables = useLocationVariables([LocationVarKey.S3AnalyticsDir]);

  useEffect(() => {
    API.S3.getAnalyticsReportURLs(Member.orgId!).then((urls) => {
      setAnalyticsReportURLs(urls);
    });
    // API.LocationVars.getVar(LocationVarKey.S3AnalyticsDir, Member.orgId!).then((dirName) => {
    //   setDirectoryName(dirName);
    // })
  }, []);

  const directoryName = variables?.[LocationVarKey.S3AnalyticsDir];

  return (
    <div className="flex flex-col p-5">
      <h1 className="text-3xl text-grey-800">Monthly Analytics Reports</h1>
      {directoryName ? (
        <h2>{directoryName}</h2>
      ) : (
        <p>
          An S3 directory is not configured for this organization. Feel free to contact <a href="mailto:support@tryswivl.com">support@tryswivl.com</a>{" "}
          for more information.
        </p>
      )}

      {directoryName && analyticsReportURLs.length > 0 ? (
        analyticsReportURLs.map((url) => (
          <a href={url.link} key={url.link} target="_blank" rel="noreferrer">
            {url.name}
          </a>
        ))
      ) : (
        <p>
          No historical analytics reports are available. Click <a href="https://v3.swivl.studio">here</a> to be taken to your Dashboard.
        </p>
      )}
      <br />
    </div>
  );
}
